import { useState } from 'react'
import styled from '@emotion/styled'
import Button from 'antd/lib/button'

import TabContent from './TabContent'

const LMS = () => {
  const [current, setCurrent] = useState(1)
  const handleClickTab = (tabNumber) => setCurrent(tabNumber)
  const getType = (tabNumber) => {
    if (current === tabNumber) return 'primary-fill'
    return 'primary'
  }

  return (
    <Page>
      <div className='intro-finnovo'>
        <img class='intro-finnovo-bg' src='/finnovo/jigsaw.jpg' alt='' />
        <div className='intro-finnovo-content'>
          <div className='compony-name'>Loan Origination System</div>

          <div className='intro-compony-info'>
            <div className='intro-compony-info-center'>
              Our loan origination module allows lenders to automate the client onboarding and loan
              underwriting process, resulting in optimized conversion rate and maximizing the
              opportunity of qualified clients into your portfolio.
            </div>
          </div>
        </div>
      </div>
      <div className='content-page'>
        <div className='content-page-header'>
          <Button type={getType(1)} onClick={() => handleClickTab(1)}>
            Client Onboarding
          </Button>
          <Button type={getType(2)} onClick={() => handleClickTab(2)}>
            Decision Making
          </Button>
          <Button type={getType(3)} onClick={() => handleClickTab(3)}>
            Document Management
          </Button>
          <Button type={getType(4)} onClick={() => handleClickTab(4)}>
            Report and Statistics
          </Button>
        </div>
        {current === 1 && (
          <TabContent
            title='Client Onboarding'
            textContent={
              <>
                Streamline the onboarding process from the application submission to its approval
                which can be configured specifically for different types of load products.
                <br /> - Prescreening check - Customer due diligence and risk assessment
                <br /> - Integrations with third-party providers
              </>
            }
            img='/finnovo/20944019.jpg'
            textPosition='left'
          />
        )}
        {current === 2 && (
          <TabContent
            title='Decision Making'
            textContent={
              <>
                Thoroughly evaluate the financial standing of potential borrowers. Automate
                application processing, lower operating costs and enable quicker turnaround
                on decisions.
                <br /> - Shorten time with prescreening checks
                <br /> - Build your own decision-making process/calculation
                <br /> - Integrate with third-party scoring providers - Set criterial by product
              </>
            }
            img='/finnovo/11083.jpg'
            textPosition='left'
          />
        )}
        {current === 3 && (
          <TabContent
            title='Document Management'
            textContent={
              <>
                Allow workflows to be set up and customer information and documents to be handled
                in a logical way. Automatically flag files with missing fields, easily manage
                contracts, agreements, and other system documents:
                <br />
                <br /> - Reduce time and money spent on auditing documents Sign documents
                electronically, automatically distribute copies
                <br />- Instantly access and manage all stored documents and templates
              </>
            }
            img='/finnovo/2041293.jpg'
            textPosition='left'
          />
        )}
        {current === 4 && (
          <TabContent
            title='Report and Statistics'
            textContent={
              <>
                Collect business statistics and take advantage of helpful data visualization tools.
                Enable business decision makers to be equipped with information and allows
                complicated ideas to be communicated in simple visual messages: Allow data to be
                exported Generated clear and business-driven standard dashboards Automate
                the creation of comprehensive real-time reports
              </>
            }
            img='/finnovo/8454.jpg'
            textPosition='right'
          />
        )}
      </div>
    </Page>
  )
}
const Page = styled.div`
  .intro-finnovo {
    height: 500px;

    .intro-finnovo-bg {
      /* opacity: 0.6; */
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 565px;
      object-fit: cover;
      filter: brightness(50%);
    }
    .intro-finnovo-content {
      position: relative;
      padding: 40px;
      left: 50%;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      text-align: center;

      .compony-name {
        @media only screen and (max-width: 700px) {
          font-weight: bold;
          font-size: 20px;
        }
        color: #ffffff;
        /* font-weight: bold; */
        font-size: 50px;
        padding: 20px 0;
      }
      .intro-compony-info {
        @media only screen and (max-width: 700px) {
          font-size: 16px;
        }
        display: flex;
        justify-content: center;
        color: #ffffff;
        font-size: 20px;
        .intro-compony-info-center {
          @media only screen and (max-width: 700px) {
            width: 100%;
          }
          width: 60%;
        }
      }
    }
  }
  .content-page {
    padding: 20px;
    /* height: 200px; */
    /* background: red; */
    .content-page-header {
      @media only screen and (max-width: 700px) {
        padding: 20px;
      }
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 20px 60px;
      button {
        margin: 10px 0;
        padding: 0 30px;
        height: 46px;
        font-size: 19px;
        min-width: 290px;
      }
    }
  }
`

export default LMS
